<template>
  <v-menu v-model="menu" open-on-hover open-on-focus>
    <template v-slot:activator="{ on, attrs }">
      <v-autocomplete
        color="primary"
        hide-no-data
        v-model="materialShowCategoriesSelected"
        clearable
        chips
        multiple
        deletable-chips
        small-chips
        :items="materialShowCategoriesSelected"
        :loading="materialShowCategoriesLoading"
        :search-input.sync="materialShowCategoriesSearch"
        item-text="name"
        item-value="id"
        :label="noLabel ? '' : $t('MaterialShowCategory.title')"
        return-object
        v-bind="attrs"
        v-on="on"
      >
        <template v-slot:append>
          <v-icon
            style="height: 24px; width: 24px"
            :color="menu ? 'primary' : ''"
            @click.stop="menu = !menu"
          >
            {{ menu ? "fa-caret-up" : "fa-caret-down" }}
          </v-icon>
        </template>
        <template v-slot:selection="data">
          <v-chip
            v-bind="data.attrs"
            small
            :input-value="data.selected"
            close
            @click:close="remove(data.item)"
          >
            {{
              data.item.parent_show_category
                ? data.item.parent_show_category.name + " : "
                : ""
            }}
            {{ data.item.name }}
          </v-chip>
        </template>
      </v-autocomplete>
    </template>
    <div style="max-height: 304px">
      <v-sheet>
        <v-treeview
          v-model="materialShowCategoriesSelected"
          :items="materialShowCategories"
          :search="materialShowCategoriesSearch"
          :filter="categoriesFilter"
          selection-type="independent"
          item-key="id"
          item-text="name"
          item-children="show_categories"
          open-all
          selectable
          selected-color="primary"
          hoverable
          return-object
        />
      </v-sheet>
    </div>
  </v-menu>
</template>

<style scoped>
.v-list {
  display: none !important;
}
.v-menu__content {
  margin-top: 45px;
}
</style>

<script>
import MaterialShowCategories from "@/api/material_show_categories";

export default {
  name: "SearcherMaterialShowCategories",

  props: {
    value: Array,
    noLabel: Boolean,
  },

  computed: {
    categoriesFilter() {
      return (item, search, textKey) => item[textKey].indexOf(search) > -1;
    },
  },

  created() {
    this.getMaterialShowCategoriesFromAPI();
  },

  data: () => ({
    menu: false,
    materialShowCategories: [],
    materialShowCategoriesLoading: false,
    materialShowCategoriesSearch: "",
    materialShowCategoriesSelected: [],
  }),

  methods: {
    remove(item) {
      const index = this.materialShowCategoriesSelected.indexOf(item);
      if (index >= 0) this.materialShowCategoriesSelected.splice(index, 1);
    },
    getMaterialShowCategoriesFromAPI() {
      this.materialShowCategoriesLoading = true;
      MaterialShowCategories.tree()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.materialShowCategories = response.data.show_categories;
              if (this.$route.query.show_category_id) {
                this.materialShowCategoriesSelected = [
                  this.$commonUtils.breadthQuery(
                    this.materialShowCategories,
                    this.$route.query.show_category_id,
                    "show_categories"
                  ),
                ];
              }
            }
            this.materialShowCategoriesLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.materialShowCategoriesLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.materialShowCategoriesSelected = this.value ? this.value : [];
      },
    },
    materialShowCategoriesSelected: {
      handler() {
        this.$emit("input", this.materialShowCategoriesSelected);
      },
    },
  },
};
</script>
